import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

/**
 * Layout principal de l'application
 * Header fixe en haut, sidebar fixe à gauche, contenu scrollable
 */
const MainLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-ms-gray-50">
      <Header />
      <Sidebar />
      {/* Zone de contenu principale — décalée pour le header (h-14) et la sidebar (w-56) */}
      <main className="ml-56 mt-14 p-6">
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
